/**
 * reviewOutputTypes — ParsedOutput type and parser for AI-generated review text.
 * Kept in a separate .ts file so AIReviewTabHelpers.tsx can be components-only
 * (required for Vite Fast Refresh).
 */

export interface ParsedOutput {
  quality: string;
  deliverables: string;
  behaviors: string;
}

export function parseOutput(raw: string): ParsedOutput {
  const get = (start: string, end?: string) => {
    const i = raw.indexOf(start);
    if (i === -1) return '';
    const after = raw.slice(i + start.length);
    const j = end ? after.indexOf(end) : -1;
    return (j === -1 ? after : after.slice(0, j)).trim();
  };
  return {
    quality:      get('## SECTION 1:', '## SECTION 2:'),
    deliverables: get('### FIELD 3:', '### FIELD 5:'),
    behaviors:    get('### FIELD 5:'),
  };
}
